import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Features from "./sections/Features";
import AboutPreview from "./sections/AboutPreview";
import ServicesPreview from "./sections/ServicesPreview";
import PortfolioPreview from "./sections/PortfolioPreview";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Features />
      <AboutPreview />
      <ServicesPreview />
      <PortfolioPreview />
      <CallToAction />
      <Footer />
    </div>;
}